<template>
  <div id="navse" class="navbar-wrapper" data-aos="fade-in" data-aos-once="true" :class="[ $route.name !== 'landing' ? 'not-landing' : '' ]">
    <div class="container navbar-row first is-fluid" style="margin-left:0;margin-right:0;"
      data-aos="fade-in" data-aos-once="true" v-if="phone && fax && address">
      <div class="container">
        <div class="columns navbar-full first is-gapless is-mobile">
          <div class="column navbar-brand" align="left" style="">
            <a class="navbar-logo" href="/">
              <img src="../assets/logo.svg" width="85" class="img-responsive logo-1" />
              <img src="../assets/logo-text.svg" width="360" class="img-responsive logo-2 is-hidden-mobile" />
            </a>
          </div>
          <div class="column column-link is-hidden-mobile has-text-right">
            <div class="call font-bold" style="font-size:1.2em;" v-if="phone && fax">
              Call: {{ phone }}&nbsp;&nbsp;&nbsp;Fax: {{ fax }}
            </div>
            <div class="address" v-if="address">
              {{ address }}
            </div>
          </div>
          <div class="column is-narrow navbar-menu" @click="onToggle()" data-aos="zoom-in" data-aos-once="true">
            <div class="control-menu" :class="{ active : showNav }">
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="height:120px;">
      &nbsp;
    </div>
    <div class="container navbar-row second is-fluid" style="margin-left:0;margin-right:0;">
      <div class="container">
        <div class="columns navbar-full second is-gapless is-mobile is-hidden-mobile" style="overflow:hidden;">
          <div v-for="(nav, index) in navItems"
            :key="nav.name"
            class="column column-link is-hidden-mobile"
            :class="{
              /* 'has-text-left': index === 0, */
              'has-text-centered': true, // index !== 0 && index !== (navItems.length - 1),
              /* 'has-text-right': index === (navItems.length - 1), */
              'is-active': $route.name === nav.name
            }">
            <!-- @click="$event.preventDefault();onScrollTo('landing', 'section-about')"> -->
            <a :href="`${nav.path}`">
              {{ nav.label }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/controllers/EventBus'
import Site from '@/apis/Site'
export default {
  name: 'navbarfull',
  props: ['toggle'],
  data () {
    return {
      showNav: false,
      navItems: EventBus.getNav(),
      phone: undefined,
      fax: undefined,
      address: undefined
    }
  },
  computed: {
  },
  watch: {
    toggle: function (val) {
      this.showNav = val
    },
    '$route.name': function (val) {
      // only do this when overlay mode and route change
      if (this.showNav) {
        this.onToggle()
      }
    }
  },
  beforeCreate () {
    // in this function
    // modification to data will not invoke
  },
  created () {
  },
  beforeMount () {
  },
  async mounted () {
    try {
      let data
      data = await Site.infoNamed('navbar-phone')
      if (data && data[0] && data[0].content) {
        this.phone = data[0].content
      } else {
        this.phone = undefined
      }
      data = await Site.infoNamed('navbar-fax')
      if (data && data[0] && data[0].content) {
        this.fax = data[0].content
      } else {
        this.fax = undefined
      }
      data = await Site.infoNamed('navbar-address')
      if (data && data[0] && data[0].content) {
        this.address = data[0].content
      } else {
        this.address = undefined
      }
    } catch (error) {
      this.phone = undefined
      this.fax = undefined
      this.address = undefined
      console.log('info error', error)
    }
  },
  methods: {
    onScrollTo (name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } })
      } else {
        this.$scrollTo('#' + target, { offset: -30 })
      }
    },
    onToggle: function () {
      this.showNav = !this.showNav
      var className = 'modal-open'
      var root = document.documentElement
      root.className = ''
      if (this.showNav) {
        root.className += className
      } else {
        root.className -= className
      }
      this.$emit('onToggle', this.showNav)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/app_setting.scss";
@import "./NavBarSettings.scss";

$navbar-color: white;
$navbar-overlay-color: rgba(255,255,255,0.8);

html.modal-open {
  .navbar-wrapper {
    background-color: $navbar-overlay-color;
  }
}

.navbar-wrapper {
  background-color: $navbar-color;
  // &.not-landing {
  //   // background-color: $color-primary-blue;
  // }
}

#navse {
  z-index: 20;
  // pointer-events: none;
  // padding-left: 0.75rem;
  // padding-right: 0.75rem;
  @media screen and (min-width: $tablet) {
  	// pointer-events: auto;
  }

  .navbar-row {
    &.first {
      background-color: $navbar-overlay-color;

      // only for desktop
      @media screen and (min-width: $tablet) {
        background-color: white;
      }
    }

    &.second {
      background-color: $navbar-overlay-color;

      // only for desktop
      @media screen and (min-width: $tablet) {
        background-color: $color-primary-blue;
      }
    }
  }

  .navbar-full {
    height: $navbar-height-row-1 !important;
    // padding-left: 0.75rem !important;
    // padding-right: 0.75rem !important;
    margin-bottom: 0 !important;

    // @media screen and (max-width: $tablet - 1) {
    //   height: fit-content;
    // }

    &.second {
      height: $navbar-height-row-2 !important;
    }

    align-items: center;
    text-align: center;

    // this to workaround top bar positioning
    // position: absolute;
    // top: 0;
    // right: 0;
    // width: 40%;
    // this to workaround top bar positioning

    // background-color:rgba(0,0,0,0.5);
    @media screen and (min-width: $tablet) {
    }

    // pointer-events: none;
    @media screen and (min-width: $tablet) {
      height: 80px;
    	// pointer-events: auto;
    }

    a.navbar-logo {
      .logo-1 {
        vertical-align: middle;
        max-width: auto;

        @media screen and (max-width: ($desktop - 1)) {
          width: 60px;
          padding: 5px;
          margin-left: 30px;
        }

        @media screen and (min-width: $desktop) {
          width: 80px;
          padding: 10px;
        }
      }

      .logo-2 {
        vertical-align: middle;
        max-width: auto;
        padding: 10px;

        @media screen and (max-width: ($desktop - 1)) {
          width: 280px;
          padding: 5px;
        }

        @media screen and (min-width: $desktop) {
          width: 340px;
          // padding: 15px;
        }
      }
    }

    .call {
      @media screen and (max-width: ($desktop - 1)) {
        font-size: 0.9em;
      }
    }

    .address {
      @media screen and (max-width: ($desktop - 1)) {
        font-size: 0.9em;
      }
    }

    .column {
      // padding: 0.75rem;

      &.is-active {
        a {
          background-color: $color-primary-yellow;
          color: $color-primary-blue;
        }
      }

      a {
        padding: 0.78rem;
        display: inline-block;

        // background-color: red;
        font-family: $font-family;
        color: $color-primary-yellow;
        font-weight: bold;
        // letter-spacing: 0.1em;
        text-transform: uppercase;
        width: 100%;
        &.navbar-logo {
          width: fit-content;
        }

        // padding: 10px;
        font-size: 0.9rem;
        @media screen and (max-width: ($desktop - 1)) {
          font-size: 0.85em;
        }

        &:hover {
          color: $color-white;
        }

        // @media screen and (min-width: $desktop) {
        //   padding: 10px;
        // }
        //
        // @media screen and (min-width: $fullhd) {
        //   padding: 20px;
        // }

        &.fa {
          font-size: 1.4rem;
          padding: 8px;

          &:last-child {
            padding-right: 30px;
          }
        }
      }

      &.navbar-brand,
      &.navbar-menu {
        padding: 0px;
        margin: 0px;
      }

      &.navbar-menu {
        @media screen and (min-width: $tablet) {
          margin-left: 20px;
        }
      }
    }

    .columns {
      height: 100%;
    }
  }

  .navbar-menu {
    height: 100%;
    margin: 0px;
    padding: 0px;
    margin-top: 5px;
    pointer-events: auto;
    box-shadow: 0 0 0;

    @media screen and (min-width: $tablet) {
      display: none;
    }

    // abnormal fix on resizing back and forth
    html.modal-open & {

      @media screen and (min-width: $tablet) {
        display: inherit;
      }
    }

    // cursor: pointer;
    // pointer-events: none;
    // @media screen and (min-width: $desktop) {
    // 	pointer-events: auto;
    // }

    $menu-icon-color: $color-black;

    & .control-menu {
      cursor: pointer;
      padding: 8px 25px 16px 0px;
      // left: calc(50% - 12px);
      position: absolute;
      top: 46px;
      right: 30px;

      & span {

        &, &:before, &:after {
          height: 2px;
          display: block;
          border-radius: 1px;
          background: $color-white;
          border-bottom: 2px solid $menu-icon-color;
          position: absolute;
          // top: 45%;
          // right: 15px;
          width: 25px;
          display: block;
          content: '';
          transition: all 200ms ease-in-out;

          @media screen and (min-width: $tablet) {
            height: 2px;
            width: 30px;
            top: 50%;
          }
        }

        &:before, &:after {
          right: 0px;
          width: 20px;

          @media screen and (min-width: $tablet) {
            width: 25px;
          }
        }

        &:before {
          top: -6px;

          @media screen and (min-width: $tablet) {
            top: -8px;
          }
        }

        &:after {
          top: 6px;

          @media screen and (min-width: $tablet) {
            top: 8px;
          }
        }
      }
    }

    & .active span {
      background-color: transparent;
      border-bottom: 0px;

      &:before, &:after {
        top: 0;
        right: 20px; // suppose to adjusting to same position
      }

      &:before {
        transform: rotate(45deg);
        border-bottom: 2px solid $menu-icon-color;
      }

      &:after {
        transform: rotate(-45deg);
        border-bottom: 2px solid $menu-icon-color;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// NavBarFull.vue?61c3788f